import React from 'react';

function Dowload({ stroke = '#5B5D73', width = 20, height = 20, style, className }) {
  return (
    <svg width={width} height={height} style={style} className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.33301 13.334V14.1673C3.33301 14.8304 3.5964 15.4662 4.06524 15.9351C4.53408 16.4039 5.16997 16.6673 5.83301 16.6673H14.1663C14.8294 16.6673 15.4653 16.4039 15.9341 15.9351C16.4029 15.4662 16.6663 14.8304 16.6663 14.1673V13.334" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.66634 10.0007L9.99967 13.334M9.99967 13.334L13.333 10.0007M9.99967 13.334L9.99968 3.33398" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
}

export default Dowload;
